export default __webpack_public_path__ + "static/media/Mystic's Hand-wraps of the Aureate.e9332f5e.jpg";